import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BaseComponent } from './../../../layout/main/base.component';
import { Component, LOCALE_ID, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Gender } from 'src/app/misc/enums';
import { AppConstants } from 'src/app/app.constants';
import { GetTokenBindingModel } from 'src/app/api/models/base.model';

import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { RegisterCustomerBindingModel } from 'src/app/api/models/web-booking.models';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  providers: [
    { provide: LOCALE_ID, useValue: 'en-AU' },
    { provide: MAT_DATE_LOCALE, useValue: 'en-AU' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class RegisterComponent extends BaseComponent implements OnInit {

  registerFormGroup: FormGroup;
  registerFormModel: RegisterFormModel;

  male = Gender.Male;
  female = Gender.Female;

  healthFunds = [];
  states: any[];
  selectedState: any = { suburbs: [] };
  filteredSuburbs: any[] = [];
  countries: any[];
  yesNo = [];
  genders: any[];

  isAustralianPhoneNumber: boolean;

  public modalRef: BsModalRef;
  @ViewChild('addressNotesDialog') addressNotesDialog: TemplateRef<any>;

  isAddressHasBeenClicked = false;

  ngOnInit(): void {
    this.initializeFormGroup();
    this.baseTriggerChild.subscribe(event => {
      if(this.app.config.enablePopUpDialogOnRegistrationFirstLoad)
      {
        this.app.showMessageBox(this.app.config.popUpDialogOnRegistrationMessage);
      }
      this.getHealthFunds();
    });
    this.start();
  }

  initializeFormGroup(): void {

    this.genders = [
      { value: 1, viewValue: 'Male' },
      { value: 2, viewValue: 'Female' }
    ];

    this.yesNo = [
      { value: true, viewValue: 'Yes' },
      { value: false, viewValue: 'No' }
    ];

    this.registerFormGroup = this.app.formBuilder
      .group(
        {
          firstName: new FormControl('', [Validators.required]),
          lastName: new FormControl('', [Validators.required]),
          gender: new FormControl(null, [Validators.required]),
          email: new FormControl('', [Validators.required, Validators.email]),
          confirmEmail: new FormControl('', [Validators.required, Validators.email]),
          password: new FormControl('', [Validators.required, Validators.minLength(6)]),
          confirmPassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
          mobilePhoneNumber: new FormControl('', [Validators.required]),
          acceptTerms: new FormControl(false, [Validators.requiredTrue]),
          healthFundId: new FormControl(''),
          dateOfBirth: new FormControl(null),
          isAustralianPhoneNumber: new FormControl(''),
          address1: new FormControl(''),
          address4: new FormControl(''),
          postCode: new FormControl(''),
          stateId: new FormControl(''),
          countryId: new FormControl('')
        },
        {
          validator: [MustMatch('email', 'confirmEmail'), MustMatch('password', 'confirmPassword')]
        },
      );
  }

  getHealthFunds(): void {
    this.app.spinner.show();
    const model = { branchId: this.app.branch.branchId };
    this.app.webBookingService.GetHealthFunds(model).subscribe(
      data => {
        this.healthFunds = data;
        this.getStates();
      },
      error => {
        this.showErrorMessage(error);
        this.app.spinner.hide();
      }
    );
  }

  getStates(): void {
    this.app.webBookingService.GetStates().subscribe(
      data => {
        this.states = data;
        this.getCountries();
      },
      error => {
        this.showErrorMessage(error);
        this.app.spinner.hide();
      }
    );
  }

  getCountries(): void {
    this.app.webBookingService.GetCountries().subscribe(
      data => {
        this.countries = data;
        this.app.spinner.hide();
      },
      error => {
        this.showErrorMessage(error);
        this.app.spinner.hide();
      }
    );
  }

  showAddressNotification() {
    if (this.isAddressHasBeenClicked) return;
    this.isAddressHasBeenClicked = true;
    this.app.showMessageBox(this.app.config.popUpDialogOnAddressClickMessage);
  }

  onAddress1Change(e: any) {
    setTimeout(() => {
      const model = this.registerFormGroup.getRawValue();
      if (this.app.stringService.isNotValidAddress1(model.address1)) {
        model.address1 = '';
        this.registerFormGroup.patchValue(model);
        this.showErrorMessage('PO Box is not allowed.');
        this.app.spinner.hide();
        return false;
      }
    }, 100);
  }

  closeDialog(): void {
    this.modalRef.hide();
  }

  register(): void {
    this.markFormGroupTouched(this.registerFormGroup);
    if (this.registerFormGroup.invalid) {
      this.showErrorMessage('Please fill-up required fields.');
      return;
    }

    this.app.spinner.show();
    const model = this.registerFormGroup.getRawValue();
    model.branchId = this.app.branch.branchId;
    if (this.app.stringService.isNotEmpty(model.dateOfBirth)) {
      const date = new Date(model.dateOfBirth);
      model.dateOfBirth = this.app.dateService.formatDateTime(date);
    }
    if (this.app.stringService.isEmpty(model.firstName)) {
      this.showErrorMessage('First Name is required.');
      this.app.spinner.hide();
      return;
    }
    if (this.app.stringService.isEmpty(model.lastName)) {
      this.showErrorMessage('Last Name is required.');
      this.app.spinner.hide();
      return;
    }
    if (this.app.stringService.isEmpty(model.mobilePhoneNumber)) {
      this.showErrorMessage('Mobile No. is required.');
      this.app.spinner.hide();
      return;
    }
    if (this.app.stringService.isEmpty(model.address1)) {
      this.showErrorMessage('Address 1 is required.');
      this.app.spinner.hide();
      return;
    }
    if (this.app.stringService.isNotValidAddress1(model.address1)) {
      this.showErrorMessage('PO Box is not allowed.');
      this.app.spinner.hide();
      return;
    }
    if (this.app.stringService.isEmpty(model.stateId)) {
      this.showErrorMessage('State is required.');
      this.app.spinner.hide();
      return;
    }
    if (this.app.stringService.isEmpty(model.address4)) {
      this.showErrorMessage('Suburb is required.');
      this.app.spinner.hide();
      return;
    }
    if (this.app.stringService.isEmpty(model.postCode)) {
      this.showErrorMessage('Postcode is required.');
      this.app.spinner.hide();
      return;
    }
    if (this.app.stringService.isEmpty(model.countryId)) {
      this.showErrorMessage('Country is required.');
      this.app.spinner.hide();
      return;
    }
    if (this.app.stringService.isEmpty(model.email)) {
      this.showErrorMessage('Email is required.');
      this.app.spinner.hide();
      return;
    }
    if (this.app.stringService.isEmpty(model.confirmEmail)) {
      this.showErrorMessage('Confirm email is required.');
      this.app.spinner.hide();
      return;
    }
    if (model.email != model.confirmEmail) {
      this.showErrorMessage('Email and confirm email does not match.');
      this.app.spinner.hide();
      return;
    }
    if (this.app.stringService.isEmpty(model.password)) {
      this.showErrorMessage('Password is required.');
      this.app.spinner.hide();
      return;
    }
    if (this.app.stringService.isEmpty(model.confirmPassword)) {
      this.showErrorMessage('Confirm password is required.');
      this.app.spinner.hide();
      return;
    }
    if (model.password != model.confirmPassword) {
      this.showErrorMessage('Password and confirm password does not match.');
      this.app.spinner.hide();
      return;
    }
    this.app.webBookingService.RegisterCustomer(model).subscribe(
      data => {
        this.app.storageService.setItem(AppConstants.Customer, JSON.stringify(data));
        this.getToken(model);
      },
      error => {
        var message = this.getBadRequest(error);
        if (message == "Customer basic information is already in the record.") {
          this.app.showMessageBox(this.app.config.basicInformationDuplicateMessage);
        }
        else {
          this.showErrorMessage(message);
        }
        this.app.spinner.hide();
      }
    );
  }

  getToken(customer: RegisterCustomerBindingModel): void {
    const model = new GetTokenBindingModel();
    model.email = customer.email;
    model.username = customer.email;
    model.password = customer.password;
    this.app.webBookingService.GetToken(model).subscribe(
      data => {
        this.app.storageService.setItem(AppConstants.Token, JSON.stringify(data));
        this.getCustomerProfiles();
      },
      error => {
        this.showErrorMessage(error);
        this.app.spinner.hide();
      }
    );
  }

  getCustomerProfiles(): void {
    this.app.webBookingService.GetProfile().subscribe(
      data => {
        this.app.spinner.hide();
        this.app.customer = data;
        this.app.storageService.setItem(AppConstants.Customer, JSON.stringify(this.app.customer));
        this.checkCustomerData();
        this.redirectToNextPage();
      },
      error => {
        this.showErrorMessage(error);
        this.app.spinner.hide();
      });
  }

  openTerms(): void {
    window.open(this.app.config.appUrl + '' + AppConstants.RouteTermsAndConditions, '_blank');
  }


  onStateOptionClicked(item) {
    this.selectedState = item;
    const data = this.registerFormGroup.getRawValue();
    data.postCode = '';
    data.address4 = '';
    this.registerFormGroup.patchValue(data);
  }

  onSuburbOptionClicked(item) {
    const data = this.registerFormGroup.getRawValue();
    data.postCode = item.postcode;
    this.registerFormGroup.patchValue(data);
  }

  filterSuburb(value: string): void {
    const filterValue = value.toLowerCase();

    if (this.selectedState.suburbs.length > 0) {
      this.filteredSuburbs = this.selectedState.suburbs.filter(suburb => {
        return suburb.name.toLowerCase().indexOf(filterValue) === 0;
      });
    } else {
      this.filteredSuburbs = [];
    }
  }

  //#region Reactive Form Helper
  get formGroup() { return this.registerFormGroup.controls; }

  formControlErrorMessage(formControl: string, maxlength: number = 11, minlength: number = 6): string {
    if (this.registerFormGroup.controls[formControl].touched) {
      return this.registerFormGroup.controls[formControl].hasError('required') ? 'This is field is required.' :
        this.registerFormGroup.controls[formControl].hasError('email') ? 'Must be a valid email.' :
          this.registerFormGroup.controls[formControl].hasError('minlength') ? 'Minimum length is ' + minlength + '.' :
            this.registerFormGroup.controls[formControl].hasError('maxlength') ? 'Maximum length is ' + maxlength + '.' :
              '';
    }
  }
  //#endregion

  resetMobileNumber(event: any): void {
    this.registerFormGroup.controls.mobilePhoneNumber.setValue('');
    this.registerFormGroup.patchValue(this.registerFormModel);
  }
}

export function MustMatch(controlName: string, matchingControlName: string) {

  // registerFormGroup.controls[formControl].hasError('mustMatch')
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}

export class RegisterFormModel {
  firstName: string;
  lastName: string;
  gender: Gender;
  email: string;
  confirmEmail: string;
  password: string;
  confirmPassword: string;
  mobilePhoneNumber: string;
  acceptTerms: boolean;
  healthFundId: string;
  dateOfBirth: Date;
}
